<template>

    <button  
    class="text-xs text-black hover:underline flex items-center"
    @click="shareArticle">
    <slot/> 
    
  </button>
</template>

<script setup>


// Share article function
const shareArticle = () => {
    const shareUrl = window.location.href;
    if (navigator.share) {
        try{
            navigator.share({
                title: document.title,
                url: shareUrl
            })
        }catch(error) {
            console.error('Error sharing:', error);
            alert('Failed to share the article. Please try copying the link manually.');
        }
    } else {
        // Fallback for browsers that don't support the Web Share API
        alert(`Share this article: ${shareUrl}`);
    }
};

</script>